import React from 'react';
import { createRoot } from 'react-dom/client';
import { initialiseDatadog } from './services/datadog';
import App from './App';
import * as serviceWorker from './serviceWorker';

initialiseDatadog();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

serviceWorker.unregister();
